module.exports = "/images/checkbox-rounded-checked.svg?3682c3953169ddff941e949aa4505e20";